export default "__VITE_ASSET__CDjLQOpG__"